// jshint ignore:start
/**
 * @ngdoc component
 * @name  catalog.category.component:CategoryPage
 * @requires $scope
 * @requires $timeout
 * @requires $window,
 * @requires ItxLoaderFct,
 * @requires ItxCategoryLayoutSvc,
 * @requires ItxFiltersManagerSvc,
 * @requires ItxScreenSizeSvc,
 * @requires ItxUtilsFct,
 * @requires imScrollEvent,
 * @requires imImpressionService,
 * @requires ItxXConfigSvc
 * @description
 * Main chat component.
 */
(function() {
    'use strict';

    var CategoryPageCmp = {
        bindings: {
            category: '<',
            isVisible:'<',
            realCategoryHeracles: '<',
            loadCategory: '<',
            onNavigateToProduct:'&',
            onNavigateToCategory:'&'
        },
        controller: CategoryPageCmpCtrl,
        templateUrl: 'category-page.component.html'
    };
   
    angular.module('itxApp.catalog')
        .component('categoryPage', CategoryPageCmp);

    CategoryPageCmpCtrl.$inject = [
        '$scope',
        '$rootScope',
        '$timeout', 
        '$window',
        'ItxLoaderFct',
        'ItxCategoryLayoutSvc',
        'ItxFiltersManagerSvc',
        'ItxScreenSizeSvc',
        'imGridService',        
        'ItxXConfigSvc',
        'ItxCategorySvc',
        'ItxConstants',
        'logger',
        'ngDialog',
        'imCategoryFilter',
        'CmsConfigSvc'];

    function CategoryPageCmpCtrl( 
        $scope,
        $rootScope,
        $timeout,
        $window,
        ItxLoaderFct,
        ItxCategoryLayoutSvc,
        ItxFiltersManagerSvc,
        ItxScreenSizeSvc,
        imGridService,        
        ItxXConfigSvc,
        ItxCategorySvc,
        ItxConstants,
        logger,
        ngDialog,
        imCategoryFilter,
        CmsConfigSvc
    ) {
           
        var _this = this;

        _this.imIsPage = true;
        _this.ItxCategoryLayoutSvc = ItxCategoryLayoutSvc;
        _this.ItxScreenSizeSvc = ItxScreenSizeSvc;
        
        _this.ItxLoaderFct = ItxLoaderFct;
        _this.isOpenFilter = false;
        _this.deleteFilters = false;
        _this.hasEmptySpaces = false;
        _this.refreshInterval = null;
        _this.categoryConfigured = [];
        _this.configuredProducts = [];
        
        _this.$onInit = function() {
            _this.ItxFiltersManagerSvc = ItxFiltersManagerSvc;
            ItxXConfigSvc.xmedia();

            inditex.getXconfiguracionValue('TIME_RELOAD_AJAX_REQUEST', function(status, value) {
                if (value) {
                    _this.refreshCurrentPage(value);
                }
            });
            _this.layout = _this.getLayout();
        };

        _this.$onChanges = function(changes){
            _this.categoryLoadFinished = false;
            _this.categoryMenu = false;
            if(changes.category){
                _this.filtersLoaded = false;
                if(!changes.category.isFirstChange()){
                    _this.category.init();
                }
                _this.ItxLoaderFct.show();
                _this.filteredProducts = [];
                initCategory().then(function(){
                    
                    _this.categoryLoadFinished = true;
                    $scope.$applyAsync();
                    $timeout(function(){
                        _this.ItxLoaderFct.hide();
                        _this.categoryMenu = true;
                   },200);
                });
            }
            else{
                _this.categoryMenu = true;
                _this.categoryLoadFinished = true;
            }

            if(changes.isVisible && changes.isVisible.currentValue === true){
                $rootScope.$broadcast('recent-products:update');
            }
        
            if(changes.loadCategory && changes.loadCategory.currentValue != changes.loadCategory.previousValue){
                inditex.setCategoryFilter(inditex.iCategoryId, [{}, []], []);
                _this.deleteFilters = !_this.deleteFilters;
            }

        };

        _this.showBarFilters = function(){
            return ItxFiltersManagerSvc.filterCount > 0 && ItxScreenSizeSvc.isMobile();
        };

        _this.refreshCurrentPage = function(seconds) {
            var time = seconds * 1000;
            _this.refreshInterval = setInterval(function() {
                $window.location.reload();
            }, time);
        };

        _this.$onDestroy = function() {
            if (_this.refreshInterval) {
                clearInterval(_this.refreshInterval);
                _this.refreshInterval = null;
            }
        };

        _this.getLayout = function(){            
            if(_this.ItxCategoryLayoutSvc.isExpanded()){
                return 'four-columns';
            } else {
                return 'two-columns';
            }
        };

        _this.reload = function(category) {
            _this.onNavigateToCategory({category:category});
        };

        _this.onProductClicked = function(product) {
            _this.onNavigateToProduct({product:product});
        };

        _this.onUpdateLayout= function(layout) {
            _this.layout = _this.getLayout();
            if(_this.layout === 'two-columns'){
                configProducts(_this.filteredProducts);
                if (_this.hasEmptySpaces) {
                    _this.filteredProducts= ItxCategorySvc.avoidGridSpaces(_this.filteredProducts);
                    // hacky stuff to make angular detect changes Problema con Filtros
                    // _this.filteredProducts = angular.copy(_this.filteredProducts);
                }
            }
        };

        _this.openFilters = function(){
            if(!_this.filtersLoaded){
                _this.filtersLoaded = true;
                setTimeout(() => {
                    $('body').addClass('open-filter');
                    $('body').removeClass('closed-filter');
                }, 100);
            } else {
                $('body').addClass('open-filter');
                $('body').removeClass('closed-filter');
            }
            _this.isOpenFilter = !_this.isOpenFilter;
            imCategoryFilter.createEvent('abrir_filtro');
            if(typeof hj != 'undefined'){
                hj('tagRecording', ['filtros']);   
            }
        };
        
        _this.removeFilter = function(filter){
            ItxFiltersManagerSvc.removeFilter(filter)
                .then(function(res){
                    _this._getFilteredProducts();
                });
        };

        _this._getFilteredProducts = function () {
            _this.filteredProducts = ItxFiltersManagerSvc.getFilteredProducts();
            logger.log('Products Filtered: ', _this.filteredProducts);
            _this.filter = !_this.filter;
            _this.onUpdateLayout();
        };
        
        _this.inWords = _.words;

        function configProducts(products) {
            var itemsBeforeDoubleBox = 0;
            var prevProductConfigGroup = '';

            _.each(products, function(product) {
                
                product.config = {};

                //Check if the product comes from a expanded MOCACO. It can lead to dupes in ngRepeat
                if (product.isMocaco && product.parentId) {
                    product.config.id = product.parentId + '-' + product.id;
                } else {
                    product.config.id = product.id;
                }
                //If product is a MOCACO, then we must check the BUNDLE's attributes, not the child products' attributes
                var attributes = null;
                if (product.parent) {
                    product.tags = product.parent.tags;
                    attributes = product.parent.attributes;
                } else {
                    attributes = product.attributes;
                }
                if(_this.category.config.isNoRollover){
                    product.config.isNoRollover = true;
                }

                _.each(attributes, function(attribute) {
                    
                    if (attribute.name === 'NO_ROLLOVER') {
                        product.config.isNoRollover = true;
                    }

                    if (attribute.name === 'ALT_IMAGES' && _this.category.config.showAltImages) {
                        product.config.altImage = true;
                    }

                    if (attribute.name.match(/GRID_TITLE_/) && _this.category.config.showProductGroup && prevProductConfigGroup !== attribute.value) {
                        product.config.group = {
                            'title': attribute.value,
                            'type': attribute.type
                        };
                        _this.category.config.groups.push(attribute.name);
                        prevProductConfigGroup = product.config.group ? product.config.group.title : '';
                    }
 
                    if (attribute.name.match(/ALTIMG_/)) {
                        product.config.altImg = inditex.iCategoryKey === attribute.name.replace('ALTIMG_', '');
                    }

                    // TODO Pending functionality confirmation (GRID_SECTION)
                    if (attribute.name.match(/GRID_SECTION_/)) {
                        product.config.group = {
                            'html': attribute.value
                        };
                        _this.category.config.groups.push(attribute.name);
                    }

                });

                // Test if double box in case of Xmedia is configured
                if (product && (inditex.iStoreJSON.details.xmedia !== null) && (product.activeDetail.xmedia !== null)) {
                    
                    if (product.parent && product.parent.detail && product.parent.detail.xmediaDefaultSet) {
                        product.activeDetail.xmediaDefaultSet = product.parent.detail.xmediaDefaultSet;
                    }

                    if (product.parent && product.parent.detail && product.parent.detail.defaultImageType) {
                        product.activeDetail.defaultImageType = product.parent.detail.defaultImageType;
                    }

                }

                if(_this.getLayout() ==='two-columns' ){
                    product.setLayout(ItxConstants.xmediaLocations.categoryPage, null);
                    //We use the doubleSize for double box and super box

                    if(product.layout['two-columns'].classType === 'box-double' ||  product.layout['two-columns'].classType === 'box-super'){
                        product.config.isDoubleBox = true;
                    }
                }

                if(_this.getLayout() === 'four-columns' && product.gridElemType == 'BUNDLE'){
                    product.setLayout(ItxConstants.xmediaLocations.categoryPage, null);
                }                

                if (!product.config.isDoubleBox && !product.config.isVerticalBox) {
                    itemsBeforeDoubleBox += 1;
                }
               
                //Check if there's some empty space caused by a doubleBox
                if ( (product.config.isDoubleBox  && itemsBeforeDoubleBox % 2 === 1) || product.config.isVerticalBox) {
                    _this.hasEmptySpaces = true;
                    itemsBeforeDoubleBox = 0;
                }

                product.categoryPageVisibility = product.visibility === joyr.constants.visibility.SHOW_VISIBILITY || product.visibility === joyr.constants.visibility.BACK_SOON_VISIBILITY || product.visibility === joyr.constants.visibility.COMMING_SOON_VISIBILITY;

            });
        }

        function initCategory() {         
            
            ItxFiltersManagerSvc.pagedProducts = [];
            
            imAnalytics.categoryJSON = _this.category;
          
            return new Promise((resolve, reject) => {

                if (_this.category.config.filterSize) {
                    CmsConfigSvc.getProperty(_this.category.config.filterSize.cmsKey).then(function(data) {
                        var cmsSizeConfig = data[_this.category.config.filterSize.cmsValue];
                        if (cmsSizeConfig) {
                            _this.category.config.filterSize = cmsSizeConfig.split(',')
                        } else {
                            _this.category.config.filterSize = undefined;
                        }
                    });
                }

                if (_this.category.config.filterPrice) {
                    CmsConfigSvc.getProperty(_this.category.config.filterPrice.cmsKey).then(function(data) {
                        var cmsPriceConfig = data[_this.category.config.filterPrice.cmsValue];
                        if (cmsPriceConfig) {
                            _this.category.config.filterPrice = {
                                min: cmsPriceConfig.min * 100,
                                max: cmsPriceConfig.max * 100,
                                minStep: 0,
                                maxStep: 2000 * 100
                            }
                        } else {
                            _this.category.config.filterPrice = undefined;
                        }
                    });
                }

                // _this.category.config.filterPrice = {
                //     min: 1000,
                //     max: 3000,
                //     minStep: 0,
                //     maxStep: 150000
                // }

                _.remove(_this.category.visibleProducts, function(product) {
                    return product.markToDelete === true;
                });
              
                _this.configuredProducts = _.clone(_this.category.visibleProducts);
                try { 
                    configProducts(_this.category.visibleProducts);
                } catch (e) {
                    logger.logError('ERROR', e);
                }
                
                _this.categoryConfigured = _.clone(_this.category);
                if (_this.hasEmptySpaces) {
                    _this.category.visibleProducts = ItxCategorySvc.avoidGridSpaces(_this.category.visibleProducts);
                }

                ItxFiltersManagerSvc.initialize(_this.category).then(function() {
                    
                    if (_this.category.config.filterSize || _this.category.config.filterPrice) {

                        // Buscar configuración de cms

                        if (_this.category.config.filterSize && _this.category.config.filterSize.length > 0) {
                            ItxFiltersManagerSvc.initializeCategoryPathFilter(
                                _this.category.config.filterSize
                            );
                        }
                        
                        ItxFiltersManagerSvc.applyFilters( [], [], [], undefined, undefined, _this.category.config.filterPrice, undefined )
                            .then(function(){
                                //APLICAMOS FILTROS..
                                _this._getFilteredProducts();
                                 resolve();
                            });
                    } else {
                        _this.filteredProducts = _this.category.visibleProducts;
                        resolve();
                    }
                });
            });
        }
    }

})();